import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { ElInputNumber } from "element-plus";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IntegerComponentVariableBuiltValue',
    props: {
        value: {}
    },
    emits: ["focus"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isNumber = (value) => {
            return typeof value === "number";
        };
        const valueProxy = computed(() => {
            return isNumber(props.value)
                ? props.value
                : Number(props.value);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "component-variable-value-v2 component-variable-value--integer",
                onClick: _cache[0] || (_cache[0] = ($event) => (emit('focus')))
            }, [
                _createVNode(_unref(ElInputNumber), {
                    "model-value": valueProxy.value,
                    size: "large",
                    min: 0
                }, null, 8 /* PROPS */, ["model-value"])
            ]));
        };
    }
});
